module.exports = __webpack_public_path__ + "img/success.2b287184.png";